<div *ngIf="progress > 0">
    <clr-spinner clrInline>
        Hochladen
    </clr-spinner>
    <span>
      Uploading {{progress}}%
    </span>
</div>
